//packages/shared/src/data/index.ts

import type {
  GHSValidationRulesData,
  GHSHazardData,
  GHSRecommendationsData,
  HCodes,
  IUnNumber,
  PackingGroup,
} from '@chemtracepro/types'

import type { IGHSPictogramDescription } from '@chemtracepro/types'
import ghsPictogramDescriptionsData from './ghs-pictogram-description.json'
export const ghsPictogramDescription = ghsPictogramDescriptionsData as IGHSPictogramDescription

import ghsPrecautionaryStatementsData from './ghs-precautionary-statements.json'
export const ghsPrecautionaryStatements = ghsPrecautionaryStatementsData

import ghsRecommendationsData from './ghs-recommendations.json'
export const ghsRecommendations = ghsRecommendationsData as GHSRecommendationsData

import ghsHazardData from './ghs-hazard-data.json'
export const ghsHazard = ghsHazardData as GHSHazardData

import ghsHCodesData from './ghs-h-codes.json'
export const ghsHCodes = ghsHCodesData as HCodes

import ghsValidationRulesData from './ghs-validation-rules.json'

export const ghsValidationRules = ghsValidationRulesData as unknown as GHSValidationRulesData

import dangerousGoodsData from './un-dangerous_goods_list.json'
// export const importedDangerousGoods = dangerousGoodsData

// Create a proper transformer
function transformDangerousGoodsData(rawData: any[]): IUnNumber[] {
  return rawData.map((item) => {
    // Helper to convert comma/space separated string to array
    const toArray = (str: string | null | undefined): string[] => {
      if (!str || typeof str !== 'string') return []
      return str
        .split(/[, ]+/) // Split by commas or spaces
        .filter((item) => item.trim() !== '')
    }

    return {
      unNo: item.unNo || '',
      nameAndDescription: item.nameAndDescription || '',
      classOrDivision: item.classOrDivision || '',
      subsidiaryRisk: toArray(item.subsidiaryRisk),
      packingGroup: (item.packingGroup || '') as PackingGroup,
      specialProvisions: toArray(item.specialProvisions),
      limitedQuantities: item.limitedQuantities || '',
      packingInstruction: toArray(item.packingInstruction),
      specialPackingProvisions: toArray(item.specialPackingProvisions),
      portableTankInstruction: item.portableTankInstruction || '',
      portableTankSpecialProvisions: item.portableTankSpecialProvisions || '',
    }
  })
}

export const importedDangerousGoods = transformDangerousGoodsData(dangerousGoodsData)

export { countryCityData, getCountryOptions, getCitiesForCountry, lookupCountry } from './locations'
